import { useState } from "react";
import { Plus, Minus, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { FAQS } from "@/data/business";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-white py-20 lg:py-28">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-center">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-red-600">
            Good to Know
          </p>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="mt-12 divide-y divide-slate-200 border-t border-b border-slate-200">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="font-heading text-lg font-bold text-slate-900">
                    {f.q}
                  </span>
                  <span className="grid place-items-center h-8 w-8 rounded-sm bg-slate-900 text-white shrink-0">
                    {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? "max-h-60 pb-5" : "max-h-0"
                  }`}
                >
                  <p className="text-slate-600 leading-relaxed pr-12">{f.a}</p>
                </div>
              </div>
            );
          })}
        </div>
        <div className="mt-8 text-center">
          <Link to="/faq" className="inline-flex items-center gap-1.5 font-bold text-red-600 hover:text-red-700 transition-colors" data-testid="view-all-faqs">
            View all garage door FAQs <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
